import { render } from "./Textarea.vue?vue&type=template&id=b9eec0b6&scoped=true"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"

import "./Textarea.vue?vue&type=style&index=0&id=b9eec0b6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9eec0b6"],['__file',"resources/js/components/Textarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9eec0b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9eec0b6', __exports__)) {
    console.log('reload')
    api.reload('b9eec0b6', __exports__)
  }
  
  module.hot.accept("./Textarea.vue?vue&type=template&id=b9eec0b6&scoped=true", () => {
    console.log('re-render')
    api.rerender('b9eec0b6', render)
  })

}


export default __exports__